/**
     * Convierte fecha en formato Date a String.
     * @param {Date} date - Fecha en formato Date
     * @returns {String} Fecha en formato string.
    */
function dateToString(date) {
    var mm = date.getMonth() + 1; // getMonth() comienza en 0
    var dd = date.getDate();

    return [(dd > 9 ? '' : '0') + dd,
    (mm > 9 ? '' : '0') + mm,
    date.getFullYear(),
    ].join('/');
}

export default dateToString;